/* SLIDE 6 */
/* SLIDE 7 */

import React, { useState, useEffect } from "react";
import settingIcon from "assets/icons/settingIcon.svg";
import ButtonBot from "shared/components/ButtonBot";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    setSelectedSpots,
    fetchAllParkingSpots,
    fetchAllParkingSpotTypes,
} from "features/parking/presentation/store/parkingSlice";
import SearchBar from "shared/components/SearchBar";
import SubHeader from "../../../shared/components/SubHeader";

const ParkingStatusPage2 = () => {
    const { selectedSpots, selectedSpotId, parkingSlots, parkingSpots } =
        useSelector((state) => state.parking);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAllParkingSpots());
        dispatch(fetchAllParkingSpotTypes());
    }, [dispatch]);

    const handleSettingsClick = () => {
        // setSelectedSpots([]);
        navigate("/parking_setting");
    };
    // Handling function when clicking on the parking box
    const handleSlotClick = (slotId) => {
        dispatch(setSelectedSpots(slotId));
    };

    return (
        <div className={`parking-status-container bg-status-page`}>
            <div className="header-container">
                <SubHeader>
                    <div className="nl-row j-between col">
                        <div className={`sub-header-text w-full`} >

                            <span className="htColorGray2">주차장명 : </span>
                            <span className="htBold">새마을시장(01-002)</span>

                        </div>
                        <button className="settings-button" onClick={handleSettingsClick}>
                            <img src={settingIcon} alt="setting" />
                        </button>
                    </div>

                </SubHeader>

                <SearchBar />
            </div>

            <div className="parking-grid">
                {parkingSpots?.map((spot, index) => (
                    <div
                        key={spot.id}
                        className={`parking-slot ${selectedSpots.includes(spot.id) ? "selected" : ""
                            }  ${index == 0 || index == 1 ? 'selected2' : ''}`}
                        onClick={() => index == 0 || index == 1 ? null : handleSlotClick(spot.id)}
                    >
                        <div className="slot-number">{spot.id}</div>
                        <div className={`slot-status ${index == 0 || index == 1 ? 'slot-parking' : ''}`}>

                        <span className="slot-text">{index == 0 || index == 1 ? '142호' : spot.status}</span>
                      
                            <span className="slot-car">{index == 0 || index == 1 ? '1054' : ''}</span>

                        </div>
                    </div>
                ))}
            </div>

            <ButtonBot textYes={`입차하기`} />
        </div>
    );
};

export default ParkingStatusPage2;
